/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const grantManualSubscriptionRequestSchema = z.object({
  userId: z.string(),
  planKey: z.string(),
  expiresDate: z.number().optional(),
});

export type IGrantManualSubscriptionRequest = z.infer<typeof grantManualSubscriptionRequestSchema>;
